import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getSiteConfig } from '../services/api';
import { FaFacebook, FaInstagram, FaTiktok, FaWhatsapp } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [config, setConfig] = useState(null);
  const [accountOpen, setAccountOpen] = useState(false);
  const { client, logout } = useAuth();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => {
    getSiteConfig()
      .then(res => setConfig(res.data))
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setAccountOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    setAccountOpen(false);
    navigate('/');
  };

  return (
<header className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-50">
  {/* Bandeau défilant */}
  <div className="bg-black text-yellow-400 text-xs font-semibold overflow-hidden" style={{ height: '28px' }}>
    <style>{`
      @keyframes ticker {
        0%   { transform: translateX(100%); }
        100% { transform: translateX(-100%); }
      }
    `}</style>
    <div style={{ animation: 'ticker 22s linear infinite', whiteSpace: 'nowrap', display: 'inline-block', lineHeight: '28px' }}>
      🚗 Livraison partout en France, Algérie et Tunisie &nbsp;•&nbsp; ✅ Véhicules contrôlés et certifiés &nbsp;•&nbsp; 💬 Réponse WhatsApp sous 2h &nbsp;•&nbsp; 🏆 Des centaines de clients satisfaits &nbsp;•&nbsp; 📸 Plus de photos disponibles sur demande &nbsp;•&nbsp; 🔑 Essai possible sur rendez-vous &nbsp;•&nbsp; 💰 Prix transparents, sans frais cachés &nbsp;•&nbsp;
    </div>
  </div>
  <div className="w-full px-4 py-3 flex items-center gap-4">

    <div className="flex-shrink-0 flex flex-col">
      <div className="flex items-center gap-3">
        <Link to="/" className="flex items-center">
          <span className="text-xl font-extrabold tracking-widest uppercase text-black">
            ROYAL <span className="text-yellow-500">CARS</span>
          </span>
        </Link>
        {config?.facebook && (
          <a href={config.facebook} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-blue-600 transition">
            <FaFacebook size={18} />
          </a>
        )}
        {config?.instagram && (
          <a href={config.instagram} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-pink-500 transition">
            <FaInstagram size={18} />
          </a>
        )}
        {config?.tiktok && (
          <a href={config.tiktok} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-black transition">
            <FaTiktok size={18} />
          </a>
        )}
        {config?.whatsapp && (
          <a href={`https://wa.me/${config.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-green-500 transition">
            <FaWhatsapp size={18} />
          </a>
        )}
      </div>
      <a
        href={config?.phone ? `tel:${config.phone}` : 'tel:+33647474068'}
        className="md:hidden text-yellow-500 font-bold text-xs mt-0.5 hover:text-yellow-400 transition"
      >
        {config?.phone || '+33 6 47 47 40 68'}
      </a>
    </div>

    <nav className="hidden md:flex items-center gap-3 flex-1 justify-end">
      <Link to="/" className="text-gray-700 hover:text-yellow-500 transition font-medium text-base whitespace-nowrap" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Accueil</Link>
      <Link to="/vehicules-neufs" className="text-gray-700 hover:text-yellow-500 transition font-medium text-base whitespace-nowrap">Véhicules neufs</Link>
      <Link to="/vehicules-occasion" className="text-gray-700 hover:text-yellow-500 transition font-medium text-base whitespace-nowrap">Véhicules occasion</Link>
      <Link to="/vehicules-recents" className="text-gray-700 hover:text-yellow-500 transition font-medium text-base whitespace-nowrap">- 3 ans</Link>
      <Link to="/promotions" className="text-gray-700 hover:text-yellow-500 transition font-medium text-base whitespace-nowrap">Promotions</Link>
      <Link to="/vendus" className="text-gray-700 hover:text-yellow-500 transition font-medium text-base whitespace-nowrap">Vendus</Link>
      <Link to="/about" className="text-gray-700 hover:text-yellow-500 transition font-medium text-base whitespace-nowrap">Qui sommes-nous</Link>
      <Link to="/contact" className="text-gray-700 hover:text-yellow-500 transition font-medium text-base whitespace-nowrap">Contact</Link>
      <a href={config ? `tel:${config.phone}` : 'tel:+33647474068'} className="bg-yellow-500 text-black px-4 py-2 rounded-lg font-bold hover:bg-yellow-400 transition shadow text-base whitespace-nowrap">
        Nous appeler
      </a>

      {/* Bouton compte */}
      {client ? (
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setAccountOpen(!accountOpen)}
            className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded-lg font-bold hover:bg-gray-800 transition text-sm whitespace-nowrap"
          >
            <span className="w-7 h-7 bg-yellow-500 text-black rounded-full flex items-center justify-center text-xs font-black">
              {client.prenom?.[0]?.toUpperCase()}{client.nom?.[0]?.toUpperCase()}
            </span>
            <span>{client.prenom}</span>
          </button>
          {accountOpen && (
            <div className="absolute right-0 top-full mt-2 w-52 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50">
              <div className="px-4 py-3 border-b border-gray-100">
                <p className="font-bold text-gray-900 text-sm">{client.civilite} {client.prenom} {client.nom}</p>
                <p className="text-gray-500 text-xs truncate">{client.email}</p>
              </div>
              <Link to="/mes-favoris" onClick={() => setAccountOpen(false)}
                className="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4 text-red-500">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
                Mes favoris
              </Link>
              <button onClick={handleLogout}
                className="w-full flex items-center gap-3 px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition border-t border-gray-100">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Se déconnecter
              </button>
            </div>
          )}
        </div>
      ) : (
        <Link to="/connexion" className="flex items-center gap-2 border-2 border-black text-black px-3 py-2 rounded-lg font-bold hover:bg-black hover:text-white transition text-sm whitespace-nowrap">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4">
            <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          Mon compte
        </Link>
      )}
    </nav>

    <button className="md:hidden ml-auto flex flex-col items-center gap-0.5" onClick={() => setMenuOpen(!menuOpen)}>
      <span className="text-gray-800 text-2xl leading-none">☰</span>
      <span className="text-gray-600 text-xs font-semibold uppercase tracking-wide">Menu</span>
    </button>
  </div>

  {menuOpen && (
    <div className="md:hidden bg-white border-t border-gray-200 px-4 py-4 flex flex-col gap-4">
      <Link to="/" className="text-gray-700 hover:text-yellow-500 transition" onClick={() => { setMenuOpen(false); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Accueil</Link>
      <Link to="/vehicules-neufs" className="text-gray-700 hover:text-yellow-500 transition" onClick={() => setMenuOpen(false)}>Véhicules neufs</Link>
      <Link to="/vehicules-occasion" className="text-gray-700 hover:text-yellow-500 transition" onClick={() => setMenuOpen(false)}>Véhicules occasion</Link>
      <Link to="/vehicules-recents" className="text-gray-700 hover:text-yellow-500 transition" onClick={() => setMenuOpen(false)}>- 3 ans</Link>
      <Link to="/promotions" className="text-gray-700 hover:text-yellow-500 transition" onClick={() => setMenuOpen(false)}>Promotions</Link>
      <Link to="/vendus" className="text-gray-700 hover:text-yellow-500 transition" onClick={() => setMenuOpen(false)}>Véhicules vendus</Link>
      <Link to="/about" className="text-gray-700 hover:text-yellow-500 transition" onClick={() => setMenuOpen(false)}>Qui sommes-nous</Link>
      <Link to="/contact" className="text-gray-700 hover:text-yellow-500 transition" onClick={() => setMenuOpen(false)}>Contact</Link>

      {client ? (
        <>
          <Link to="/mes-favoris" className="text-gray-700 hover:text-yellow-500 transition flex items-center gap-2" onClick={() => setMenuOpen(false)}>
            ♥ Mes favoris
          </Link>
          <button onClick={() => { handleLogout(); setMenuOpen(false); }} className="text-red-600 font-semibold text-left hover:text-red-500 transition">
            Se déconnecter
          </button>
        </>
      ) : (
        <Link to="/connexion" className="bg-black text-white px-5 py-2 rounded-lg font-bold text-center" onClick={() => setMenuOpen(false)}>
          Mon compte
        </Link>
      )}

      <div className="flex items-center gap-4">
        {config?.facebook && <a href={config.facebook} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-blue-600 transition"><FaFacebook size={22} /></a>}
        {config?.instagram && <a href={config.instagram} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-pink-500 transition"><FaInstagram size={22} /></a>}
        {config?.tiktok && <a href={config.tiktok} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-black transition"><FaTiktok size={22} /></a>}
        {config?.whatsapp && <a href={`https://wa.me/${config.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-green-500 transition"><FaWhatsapp size={22} /></a>}
      </div>
      <a href={config ? `tel:${config.phone}` : 'tel:+33647474068'} className="bg-yellow-500 text-black px-5 py-2 rounded-lg font-bold text-center">Nous appeler</a>
    </div>
  )}
</header>
  );
}

export default Header;
